import {Answer} from './answer.model';

export class Proposal {
  categoryId: number;
  productId: number;
  answers: Answer [];
  isCashback: boolean;
}



// WEBPACK FOOTER //
// ./src/app/buyback-form/main-section/shared/classes/second-tab.model.ts